<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import General from "@/services/General";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    PageHeader
  },
  page: {
    title: "VPN Connection Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      error: null,
      vpnData: [],
      title: "VPN Connection Details",
      items: [
        {
          text: "Monitor",
        },
        {
          text: "VPN User",
          active: true,
        },
      ],
    };
  },

  async created() {
    await this.getVPNUsers();
  },
  methods: {

    async getVPNUsers() {
      try {
        const response = await General.getTenantVPNUsers('username='+localStorage.getItem('username'));
        if(response.data.data[0]){
            this.vpnData = response.data.data[0];
        }
      } catch (error) {
        this.error = error.response?.data?.error || "An error occurred while fetching data.";
        this.vpnData = [];
      }
    },

    showPassword(password){
      Swal.fire({
          html: "<strong>"+password+"</strong>",
          showCancelButton: false,
          confirmButtonColor: "#34c38f",
          confirmButtonText: "OK",
      })
    },

  },
  middleware: "authentication",
};

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" >
          <div class="card-body text-center">
              <h4>VPN Connection Details</h4>
              <br>
              <h5>Username:</h5>
              <h5>{{vpnData.username}}</h5>
              <br>
              <h5>Password:</h5>
              <h5>{{vpnData.username}}</h5>
          </div>
        </div>
        <div class="card">
            <div class="card-body ">
                <b-tabs justified class="nav-tabs-custom">
                    <b-tab active>
                        <template v-slot:title>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22 2L11.2 3.6v8l10.8-.1zM10.2 12.5L2 12.4v6.8l8.1 1.1zM2 4.8v6.8h8.1V3.7zm9.1 7.7v7.9L22 22v-9.4z"/></svg>
                            <span class="d-none d-sm-block">Windows Guide</span>
                        </template>

                        <div class="container mt-5">
                            <h2 class="mb-4 text-primary">How to Connect to a VPN on Windows 11</h2>

                            <h4>Step 1: Open VPN Settings</h4>
                            <ul>
                                <li>Press <kbd>Win + I</kbd> to open <strong>Settings</strong>.</li>
                                <li>Go to <strong>Network & Internet</strong> > <strong>VPN</strong>.</li>
                            </ul>

                            <h4>Step 2: Add a VPN Connection</h4>
                            <ul>
                                <li>Click <strong>Add VPN</strong>.</li>
                                <li>Fill in the required details:</li>
                                <ul>
                                    <li><strong>VPN provider:</strong> Choose <em>Windows (built-in)</em>.</li>
                                    <li><strong>Connection name:</strong> Enter a name (e.g., "Work VPN").</li>
                                    <li><strong>Server name or address:</strong> Enter the VPN server address.</li>
                                    <li><strong>VPN type:</strong> Select the protocol (e.g., PPTP, L2TP/IPsec, SSTP, IKEv2).</li>
                                    <li><strong>Type of sign-in info:</strong> Choose <em>Username and password</em>.</li>
                                </ul>
                                <li>Click <strong>Save</strong>.</li>
                            </ul>

                            <h4>Step 3: Connect to the VPN</h4>
                            <ul>
                                <li>Go back to <strong>Settings</strong> > <strong>Network & Internet</strong> > <strong>VPN</strong>.</li>
                                <li>Select the VPN connection and click <strong>Connect</strong>.</li>
                                <li>If prompted, enter your username and password.</li>
                            </ul>
                        </div>
                    </b-tab>
                    <b-tab >
                        <template v-slot:title>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M19.7 17.6c-.1-.2-.2-.4-.2-.6c0-.4-.2-.7-.5-1c-.1-.1-.3-.2-.4-.2c.6-1.8-.3-3.6-1.3-4.9c-.8-1.2-2-2.1-1.9-3.7c0-1.9.2-5.4-3.3-5.1c-3.6.2-2.6 3.9-2.7 5.2c0 1.1-.5 2.2-1.3 3.1c-.2.2-.4.5-.5.7c-1 1.2-1.5 2.8-1.5 4.3c-.2.2-.4.4-.5.6c-.1.1-.2.2-.2.3c-.1.1-.3.2-.5.3c-.4.1-.7.3-.9.7c-.1.3-.2.7-.1 1.1c.1.2.1.4 0 .7c-.2.4-.2.9 0 1.4c.3.4.8.5 1.5.6c.5 0 1.1.2 1.6.4c.5.3 1.1.5 1.7.5c.3 0 .7-.1 1-.2c.3-.2.5-.4.6-.7c.4 0 1-.2 1.7-.2c.6 0 1.2.2 2 .1c0 .1 0 .2.1.3c.2.5.7.9 1.3 1h.2c.8-.1 1.6-.5 2.1-1.1c.4-.4.9-.7 1.4-.9c.6-.3 1-.5 1.1-1c.1-.7-.1-1.1-.5-1.7M12.8 4.8c.6.1 1.1.6 1 1.2q0 .45-.3.9h-.1c-.2-.1-.3-.1-.4-.2c.1-.1.1-.3.2-.5c0-.4-.2-.7-.4-.7c-.3 0-.5.3-.5.7v.1c-.1-.1-.3-.1-.4-.2V6c-.1-.5.3-1.1.9-1.2m-.3 2c.1.1.3.2.4.2s.3.1.4.2c.2.1.4.2.4.5s-.3.6-.9.8c-.2.1-.3.1-.4.2c-.3.2-.6.3-1 .3c-.3 0-.6-.2-.8-.4c-.1-.1-.2-.2-.4-.3c-.1-.1-.3-.3-.4-.6c0-.1.1-.2.2-.3c.3-.2.4-.3.5-.4l.1-.1c.2-.3.6-.5 1-.5c.3.1.6.2.9.4M10.4 5c.4 0 .7.4.8 1.1v.2c-.1 0-.3.1-.4.2v-.2c0-.3-.2-.6-.4-.5c-.2 0-.3.3-.3.6c0 .2.1.3.2.4c0 0-.1.1-.2.1c-.2-.2-.4-.5-.4-.8c0-.6.3-1.1.7-1.1m-1 16.1c-.7.3-1.6.2-2.2-.2c-.6-.3-1.1-.4-1.8-.4c-.5-.1-1-.1-1.1-.3s-.1-.5.1-1q.15-.45 0-.9c-.1-.3-.1-.5 0-.8s.3-.4.6-.5s.5-.2.7-.4c.1-.1.2-.2.3-.4c.3-.4.5-.6.8-.6c.6.1 1.1 1 1.5 1.9c.2.3.4.7.7 1c.4.5.9 1.2.9 1.6c0 .5-.2.8-.5 1m4.9-2.2c0 .1 0 .1-.1.2c-1.2.9-2.8 1-4.1.3l-.6-.9c.9-.1.7-1.3-1.2-2.5c-2-1.3-.6-3.7.1-4.8c.1-.1.1 0-.3.8c-.3.6-.9 2.1-.1 3.2c0-.8.2-1.6.5-2.4c.7-1.3 1.2-2.8 1.5-4.3c.1.1.1.1.2.1c.1.1.2.2.3.2c.2.3.6.4.9.4h.1c.4 0 .8-.1 1.1-.4c.1-.1.2-.2.4-.2q.45-.15.9-.6c.4 1.3.8 2.5 1.4 3.6c.4.8.7 1.6.9 2.5c.3 0 .7.1 1 .3c.8.4 1.1.7 1 1.2H18c0-.3-.2-.6-.9-.9s-1.3-.3-1.5.4c-.1 0-.2.1-.3.1c-.8.4-.8 1.5-.9 2.6c.1.4 0 .7-.1 1.1m4.6.6c-.6.2-1.1.6-1.5 1.1c-.4.6-1.1 1-1.9.9c-.4 0-.8-.3-.9-.7c-.1-.6-.1-1.2.2-1.8c.1-.4.2-.7.3-1.1c.1-1.2.1-1.9.6-2.2c0 .5.3.8.7 1c.5 0 1-.1 1.4-.5h.2c.3 0 .5 0 .7.2s.3.5.3.7c0 .3.2.6.3.9c.5.5.5.8.5.9c-.1.2-.5.4-.9.6m-9-12c-.1 0-.1 0-.1.1c0 0 0 .1.1.1s.1.1.1.1c.3.4.8.6 1.4.7c.5-.1 1-.2 1.5-.6l.6-.3c.1 0 .1-.1.1-.1c0-.1 0-.1-.1-.1c-.2.1-.5.2-.7.3c-.4.3-.9.5-1.4.5s-.9-.3-1.2-.6c-.1 0-.2-.1-.3-.1"/></svg>                            <span class="d-none d-sm-block">Linux Guide</span>
                        </template>

                        <div class="container mt-5">
                            <h2 class="mb-4 text-primary">How to Connect to a VPN on Linux</h2>

                            <h4>Method 1: Using Network Manager (GUI)</h4>

                            <h4>Step 1: Open Network Settings</h4>
                            <ul>
                                <li>Open <strong>Settings</strong> and go to <strong>Network</strong>.</li>
                                <li>Click <strong>VPN</strong> and then <strong>Add</strong>.</li>
                            </ul>

                            <h4>Step 2: Configure VPN</h4>
                            <ul>
                                <li>Select the VPN type (e.g., **OpenVPN**, **L2TP**, **PPTP**).</li>
                                <li>Enter the **VPN server address** provided by your service.</li>
                                <li>Enter your **username and password**.</li>
                                <li>Click <strong>Save</strong>.</li>
                            </ul>

                            <h4>Step 3: Connect to the VPN</h4>
                            <ul>
                                <li>Go back to **Network Settings**.</li>
                                <li>Select the VPN you just added.</li>
                                <li>Click **Connect**.</li>
                            </ul>

                        </div>
                    </b-tab>
                    <b-tab >
                        <template v-slot:title>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M14.94 5.19A4.38 4.38 0 0 0 16 2a4.44 4.44 0 0 0-3 1.52a4.17 4.17 0 0 0-1 3.09a3.69 3.69 0 0 0 2.94-1.42m2.52 7.44a4.51 4.51 0 0 1 2.16-3.81a4.66 4.66 0 0 0-3.66-2c-1.56-.16-3 .91-3.83.91s-2-.89-3.3-.87a4.92 4.92 0 0 0-4.14 2.53C2.93 12.45 4.24 17 6 19.47c.8 1.21 1.8 2.58 3.12 2.53s1.75-.82 3.28-.82s2 .82 3.3.79s2.22-1.24 3.06-2.45a11 11 0 0 0 1.38-2.85a4.41 4.41 0 0 1-2.68-4.04"/></svg>                            <span class="d-none d-sm-block">MacOS Guide</span>
                        </template>

                        <div class="container mt-5">
                            <h2 class="mb-4 text-primary">How to Connect to a VPN on macOS</h2>

                            <h4>Method 1: Using macOS Built-in VPN</h4>

                            <h4>Step 1: Open Network Preferences</h4>
                            <ul>
                                <li>Click the **Apple Menu** and go to <strong>System Settings</strong> (or <strong>System Preferences</strong> on older macOS versions).</li>
                                <li>Click **Network**.</li>
                                <li>Click the <strong>+</strong> button to add a new network connection.</li>
                            </ul>

                            <h4>Step 2: Configure the VPN</h4>
                            <ul>
                                <li>For <strong>Interface</strong>, choose **VPN**.</li>
                                <li>For <strong>VPN Type</strong>, select **L2TP over IPSec**, **IKEv2**, or **PPTP** (if available).</li>
                                <li>Enter a **Service Name** (e.g., "Work VPN").</li>
                                <li>Click <strong>Create</strong>.</li>
                                <li>Enter the **Server Address** and **Account Name** provided by your VPN provider.</li>
                                <li>Click <strong>Authentication Settings</strong> and enter your **password or shared secret key**.</li>
                                <li>Click <strong>Apply</strong> to save settings.</li>
                            </ul>

                            <h4>Step 3: Connect to the VPN</h4>
                            <ul>
                                <li>Go back to **System Settings** > **Network**.</li>
                                <li>Select the VPN connection you just created.</li>
                                <li>Click **Connect**.</li>
                            </ul>

                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
      </div>
    </div>
    <!-- MODALS -->
    <!-- /MODALS -->
  </Layout>
</template>

